module.exports = __webpack_public_path__ + "img/9788977284982.7d1ad83d.jpg";